(function() { module.exports = this["wp"]["reduxRoutine"]; }());